import React from 'react';
import PropTypes from 'prop-types';
import './ShowMore.css';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const ShowMore = ({
  isOpen,
  toggleFunction,
  moreLabel,
  lessLabel,
}) => (
  <button
    type="button"
    className="show-more-toggler"
    onClick={() => toggleFunction()}
  >
    {isOpen ? <>{lessLabel}<ExpandLessIcon/></> : <>{moreLabel}<ExpandMoreIcon/></>}
  </button>
);

ShowMore.propTypes = {
  isOpen: PropTypes.bool,
  toggleFunction: PropTypes.func.isRequired,
  moreLabel: PropTypes.string,
  lessLabel: PropTypes.string,
};

ShowMore.defaultProps = {
  isOpen: false,
  moreLabel: 'näytä kaikki',
  lessLabel: 'näytä vähemmän',
};

export default ShowMore;
